/*!
* FitVids 1.0.3
*
* Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
* Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
* Released under the WTFPL license - http://sam.zoy.org/wtfpl/
*
* Date: Thu Sept 01 18:00:00 2011 -0500
*/
(function (a) {
  a.fn.fitVids = function (b) {
    const c = { customSelector: null }; if (!document.getElementById('fit-vids-style')) {
      const f = document.createElement('div'); const d = document.getElementsByTagName('base')[0] || document.getElementsByTagName('script')[0]; const e = '&shy;<style>.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>'; f.className = 'fit-vids-style'; f.id = 'fit-vids-style'; f.style.display = 'none'; f.innerHTML = e; d.parentNode.insertBefore(f, d);
    } if (b) {
      a.extend(c, b);
    } return this.each(function () {
      const g = ["iframe[src*='player.vimeo.com']", "iframe[src*='youtube.com']", "iframe[src*='youtube-nocookie.com']", "iframe[src*='kickstarter.com'][src*='video.html']", 'object', 'embed']; if (c.customSelector) {
        g.push(c.customSelector);
      } let h = a(this).find(g.join(',')); h = h.not('object object'); h.each(function () {
        const m = a(this); if (this.tagName.toLowerCase() === 'embed' && m.parent('object').length || m.parent('.fluid-width-video-wrapper').length) {
          return;
        } const i = (this.tagName.toLowerCase() === 'object' || (m.attr('height') && !isNaN(parseInt(m.attr('height'), 10)))) ? parseInt(m.attr('height'), 10) : m.height(); const j = !isNaN(parseInt(m.attr('width'), 10)) ? parseInt(m.attr('width'), 10) : m.width(); const k = i / j; if (!m.attr('id')) {
          const l = `fitvid${Math.floor(Math.random() * 999999)}`; m.attr('id', l);
        }m.wrap('<div class="fluid-width-video-wrapper"></div>').parent('.fluid-width-video-wrapper').css('padding-top', `${k * 100}%`); m.removeAttr('height').removeAttr('width');
      });
    });
  };
}(window.jQuery || window.Zepto));
